import ApiBase from '../../api-base'
import {ACTIVE_BASE_REST} from '../../constants'

export default class Shipment extends ApiBase {
    constructor(store) {
        const path = ACTIVE_BASE_REST + '/tariff/record/auction'
        super(store, path)
    }

}